import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ff276ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-upload" }
const _hoisted_2 = { class: "upload-buttons" }
const _hoisted_3 = {
  key: 0,
  class: "preview-container"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "preview-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_spacer_break = _resolveComponent("spacer-break")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Button, {
        onClick: _ctx.triggerCamera,
        label: "Add Photo",
        icon: "pi pi-camera",
        class: "p-button-lg"
      }, null, 8, ["onClick"])
    ]),
    _createElementVNode("input", {
      ref: "fileInput",
      type: "file",
      accept: "image/*",
      style: {"display":"none"},
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args)))
    }, null, 544),
    _createElementVNode("input", {
      ref: "cameraInput",
      type: "file",
      accept: "image/*",
      capture: "environment",
      style: {"display":"none"},
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args)))
    }, null, 544),
    (_ctx.preview)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_spacer_break),
          _createElementVNode("img", {
            src: _ctx.preview,
            alt: "Preview",
            class: "image-preview"
          }, null, 8, _hoisted_4),
          _createVNode(_component_spacer_break),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              onClick: _ctx.clearImage,
              label: "Clear",
              icon: "pi pi-times",
              class: "p-button-secondary"
            }, null, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}